import { useAuthStore } from 'src/common/store'
import { onSignalREvent } from '../../signalRBus'
import { useLoader } from '../../../hooks/useLoader'
import { APIS, LOADERS } from 'src/config/constants'
import { IMessage } from 'src/interfaces/common'
import { usePerStore } from 'src/stores'
import { useMessagingServiceStore } from 'src/stores/messaging.service.store'
import { SIGNAL_R_MESSAGES, SIGNAL_R_SCOPES } from 'src/signalR/types'

type AdminUnreadMessagesCount = Record<string, Record<string, number>>

onSignalREvent(
  SIGNAL_R_SCOPES.system,
  SIGNAL_R_MESSAGES.getAdminUnreadMessages,
  (text) => {
    const authStore = useAuthStore()
    const isClient = authStore.isClient
    if (isClient) return
    const perStore = usePerStore()
    if (useMessagingServiceStore().isInitialized) return
    const centerId = text.split('_')[1]
    const localCenterId = authStore.currentCenterId
    if (localCenterId === centerId) {
      const { useFetchLoader: fetchAdminUnreadMessagesCount } =
        useLoader<AdminUnreadMessagesCount>(LOADERS.per, {
          uri: 'unreadMessagesCount',
        })
      void fetchAdminUnreadMessagesCount().then((result) => {
        if (result) perStore.setAdminUnreadMessages(result)
        else perStore.setAdminUnreadMessages(null)
      })
      if (perStore.messagingSelectedMemberId) {
        const { useFetchLoader } = useLoader<IMessage[]>(LOADERS.per, {
          uri: `${APIS.members}/${perStore.messagingSelectedMemberId}/${APIS.messages}`,
        })
        const opts = {
          params: {
            updateActivity: false,
          },
        }
        void useFetchLoader(opts).then((result) =>
          perStore.setMessages(result ?? []),
        )
      }
    }
  },
)
